import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';

import Sidebar from '../../bamburgh-theme/layout-components/Sidebar';
import Header from '../../bamburgh-theme/layout-components/Header';
import Footer from '../../bamburgh-theme/layout-components//Footer';
import { getUserTermsAcceptance, handleSubmitTermsAcceptance } from '@/pages/Profile/store/Profile'
import TermsOfUseModal from "@/components/Modal/TermsOfUseModal";
import { makeStyles } from 'tss-react/mui';
import { Outlet, useLocation } from 'react-router-dom';
import { forgetRememberedLists, isFreshListVisit, markFreshListVisitUsed } from '@/helpers/FreshListVisit';
import RoutePageTitle from '@/components/ui/RoutePageTitle';

const useStyles = makeStyles()((theme) => ({

}))

const LeftSidebar = props => {
    // Each sidebar click carries a new "freshList" value; the page restarts when it changes (other navigation keeps it).
    const location = useLocation();
    const freshPageKey = useRef<number>(0);
    const freshList = (location.state as any)?.freshList;
    if (freshList && freshList !== freshPageKey.current) {
        freshPageKey.current = freshList;
        // A new sidebar click (not a Back to an older one): start the whole flow over, before the page reads anything.
        if (isFreshListVisit(location.state)) forgetRememberedLists();
    }

    // A new page (or a sidebar restart of the same page) opens at the top, not at the scroll position of the page
    // you came from. Paging / filtering within a page only changes the address query, so it does not jump; a list
    // you come back to scrolls to its row itself once its rows have loaded.
    useEffect(() => {
        window.scrollTo(0, 0);
        // Leaving a page opened from the sidebar: coming back to it (browser Back) is a return, not a fresh list.
        const openedWith = location.state;
        return () => markFreshListVisitUsed(openedWith);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location.pathname, freshPageKey.current]);
    const {
        children,
        sidebarToggle,
        sidebarToggleMobile,
        sidebarFixed,
        headerFixed,
        headerSearchHover,
        headerDrawerToggle,
        footerFixed,
        contentBackground,
        getTermsAcceptance_d,
        handleSubmitTermsAcceptance_d,
        userTermsAcceptance,
    } = props;

    const { classes, cx } = useStyles();

    const [termsOfUseModal, setTermsOfUseModal] = React.useState<boolean>(false);


    useEffect(() => {
        getTermsAcceptance_d();
    }, []);

    useEffect(() => {
        if (userTermsAcceptance === false) {
            setTermsOfUseModal(true);
        }
    }, [userTermsAcceptance])


    const onSubmit = () => {
        setTermsOfUseModal(false);
        handleSubmitTermsAcceptance_d();
    };

    return (
        <>
            <TermsOfUseModal
                onSubmit={() => onSubmit()}
                isDialogOpened={termsOfUseModal}
                handleCloseDialog={() => setTermsOfUseModal(false)}
            />
            <div
                className={cx('app-wrapper', contentBackground, {
                    'headerDrawerOpen': headerDrawerToggle,
                    'app-sidebar-collapsed': !sidebarToggle,
                    'app-sidebar-mobile-open': sidebarToggleMobile,
                    'app-sidebar-fixed': sidebarFixed,
                    'app-header-fixed': headerFixed,
                    'app-footer-fixed': footerFixed,
                    'search-wrapper-open': headerSearchHover
                })}>

                <div>
                    <Sidebar />
                </div>
                <div className="app-main">
                    <Header />
                    <div className='app-content'>
                        <div className='app-content--inner'>
                            <div className='app-content--inner__wrapper' >
                                <RoutePageTitle />
                                {/* A sidebar click (fresh list) restarts the page, even when it is the page already open. */}
                                <Outlet key={freshPageKey.current} />
                            </div>
                            <Footer />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

LeftSidebar.propTypes = {
    children: PropTypes.node
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        getTermsAcceptance_d: () => dispatch(getUserTermsAcceptance()),
        handleSubmitTermsAcceptance_d: () => dispatch(handleSubmitTermsAcceptance()),
    }
}

const mapStateToProps = state => ({
    sidebarToggle: state.ThemeOptions.sidebarToggle,
    sidebarToggleMobile: state.ThemeOptions.sidebarToggleMobile,
    sidebarFixed: state.ThemeOptions.sidebarFixed,
    headerFixed: state.ThemeOptions.headerFixed,
    headerSearchHover: state.ThemeOptions.headerSearchHover,
    headerDrawerToggle: state.ThemeOptions.headerDrawerToggle,

    footerFixed: state.ThemeOptions.footerFixed,

    contentBackground: state.ThemeOptions.contentBackground,
    userTermsAcceptance: state.account.userTermsAcceptance
});

export default connect(mapStateToProps, mapDispatchToProps)(LeftSidebar);